import { createContext, useContext } from 'react';
import type { Branch } from '@/features/auth/types';

/** `null` = "All" (group view), only offered to finance, clinic manager and super admin. */
export type BranchSelection = Branch | null;

export interface BranchContextValue {
  branches: Branch[];
  selected: BranchSelection;
  canSelectAll: boolean;
  select: (branchId: string | 'all') => void;
}

export const BranchContext = createContext<BranchContextValue | null>(null);

export function useBranch(): BranchContextValue {
  const ctx = useContext(BranchContext);
  if (!ctx) throw new Error('useBranch must be used inside <BranchProvider>');
  return ctx;
}
